import {
  SponsoredProductAction,
  SponsoredProductActionType,
  SponsoredProductState,
} from "../types/sponsoredProducts"

const initialState: SponsoredProductState = {
  campaignData: {
    campaigns: [],
    settings: null,
    limitedCPC: null,
    targetAcos: 0,
    lastDateWithoutData: "",
  },
  loading: false,
  error: null,
}

export const sponsoredProductReducer = (
  state = initialState,
  action: SponsoredProductAction
): SponsoredProductState => {
  switch (action.type) {
    case SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_SUCCESS:
      return {
        campaignData: action.payload,
        loading: false,
        error: null,
      }
    case SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_CAMPAIGNS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
